<template lang="pug">
    v-card.mx-auto(max-width='100%')
        v-btn(fab small color="primary" @click="$emit('close')" style="position: absolute; z-index: 999; top: 10px; right: 0px;")
            v-icon.primary.rounded mdi-close
        v-col(cols="12" md="12" style="max-height: 600px;")
            gmap-map(:center="direction" :zoom="zoom" style="width:100%;  height: 500px;" :options="option")
                gmap-marker(:key="index" v-for="(m, index) in markers" :animation="2" :position="m.position" :clickable="false")
</template>

<script>
  export default {
    props: {
      direction: null,
    },
    data () {
      return {
        zoom: 16,
        center: { lat: 37.0902405, lng: -95.7128906 },
        markers: [],
        option: {
          gestureHandling: 'greedy',
          zoomControl: true,
          mapTypeControl: false,
          scaleControl: true,
          streetViewControl: false,
          rotateControl: false,
          fullscreenControl: false,
          disableDefaultUi: true,
          styles: [
            { elementType: 'geometry', stylers: [{ color: '#ebe3cd' }] },
            { elementType: 'labels.text.fill', stylers: [{ color: '#523735' }] },
            { elementType: 'labels.text.stroke', stylers: [{ color: '#f5f1e6' }] },
            {
              featureType: 'administrative',
              elementType: 'geometry.stroke',
              stylers: [{ color: '#cbe7f4' }],
            },
            {
              featureType: 'administrative.land_parcel',
              elementType: 'geometry.stroke',
              stylers: [{ color: '#d4d9dc' }],
            },
            {
              featureType: 'administrative.land_parcel',
              elementType: 'labels.text.fill',
              stylers: [{ color: '#a7aeaa' }],
            },
            {
              featureType: 'landscape.natural',
              elementType: 'geometry',
              stylers: [{ color: '#a0c49a' }],
            },
            {
              featureType: 'poi',
              elementType: 'geometry',
              stylers: [{ color: '#dfd2ae' }],
            },
            {
              featureType: 'poi',
              elementType: 'labels.text.fill',
              stylers: [{ color: '#93817c' }],
            },
            {
              featureType: 'poi.park',
              elementType: 'geometry.fill',
              stylers: [{ color: '#a5b076' }],
            },
            {
              featureType: 'poi.park',
              elementType: 'labels.text.fill',
              stylers: [{ color: '#447530' }],
            },
            {
              featureType: 'road',
              elementType: 'geometry',
              stylers: [{ color: '#f5f1e6' }],
            },
            {
              featureType: 'road.arterial',
              elementType: 'geometry',
              stylers: [{ color: '#fdfcf8' }],
            },
            {
              featureType: 'road.highway',
              elementType: 'geometry',
              stylers: [{ color: '#f8c967' }],
            },
            {
              featureType: 'road.highway',
              elementType: 'geometry.stroke',
              stylers: [{ color: '#e9bc62' }],
            },
            {
              featureType: 'road.highway.controlled_access',
              elementType: 'geometry',
              stylers: [{ color: '#e98d58' }],
            },
            {
              featureType: 'road.highway.controlled_access',
              elementType: 'geometry.stroke',
              stylers: [{ color: '#db8555' }],
            },
            {
              featureType: 'road.local',
              elementType: 'labels.text.fill',
              stylers: [{ color: '#806b63' }],
            },
            {
              featureType: 'transit.line',
              elementType: 'geometry',
              stylers: [{ color: '#dfd2ae' }],
            },
            {
              featureType: 'transit.line',
              elementType: 'labels.text.fill',
              stylers: [{ color: '#8f7d77' }],
            },
            {
              featureType: 'transit.line',
              elementType: 'labels.text.stroke',
              stylers: [{ color: '#ebe3cd' }],
            },
            {
              featureType: 'transit.station',
              elementType: 'geometry',
              stylers: [{ color: '#dfd2ae' }],
            },
            {
              featureType: 'water',
              elementType: 'geometry.fill',
              stylers: [{ color: '#b9d3c2' }],
            },
            {
              featureType: 'water',
              elementType: 'labels.text.fill',
              stylers: [{ color: '#92998d' }],
            },
          ],
        },
      }
    },
    mounted () {
      const vm = this
      vm.markers.push({ position: vm.direction })
    },
  }
</script>
